import styled from 'styled-components';

export const ProfileImage = styled.img`
  border-radius: 2px;
  padding: 2px;
  border: 2px solid ${props => props.theme.secondary};
`;
